export enum SuccessModalType {
  SAFE_CREATED = 'SAFE_CREATED',
  SAFE_MULTIPLE_OWNER_CREATED = ' SAFE_MULTIPLE_OWNER_CREATED',
  INVITE_ACCEPTED = 'INVITE_ACCEPTED',
  ERROR = 'ERROR',
}

export enum NETWORK {
  TESTNET = 'testnet',
  MAINNET = 'mainnet',
}

export enum StxChainEnum {
  testnet = 'stx:testnet',
  mainnet = 'stx:mainnet',
}

export enum SafeOwnerVariants {
  CREATE_SAFE = 'CREATE_SAFE',
  SIGNING_FLOW_MODAL = 'SIGNING_FLOW_MODAL',
}

export enum LabelColors {
  GREEN = 'GREEN',
  GRAY = 'GRAY',
  WHITE = 'WHITE',
}
